<template>
  <div class="bigData-index">
    <dataTop :Width='Width'/>
    <div class="message-title">
      <div class="message-l">消息中心</div>
      <div class="message-r">时间范围</div>
      <div>
        <el-date-picker
                v-model="data"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="onChange"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
    </div>
    <div class="message-frame">
      <div class="message-main">
        <div class="title">360PAI拍卖消息公告</div>
        <div class="category">
          <div :class="auction===''?'item active':'item'">
            <div class="type" @click="selectAuction('')">全部</div>
          </div>
          <div :class="auction==='1'?'item active':'item'">
            <div class="type" @click="selectAuction('1')">竞拍公告</div>
          </div>
          <div :class="auction==='2'?'item active':'item'">
            <div class="type" @click="selectAuction('2')">开拍通知</div>
          </div>
          <div :class="auction==='3'?'item active':'item'">
            <div class="type" @click="selectAuction('3')">成交通知</div>
          </div>
        </div>
        <div class="message-data">
          <div v-if="loading" style="width: 100%;height: 100px;line-height: 100px;text-align: center;">

          </div>
          <div v-else>
            <div v-if="auctionList.length">
              <a target="_blank" :href="item.href" class="message-line" v-for="(item,index) in auctionList" :key="index">
                <div class="line-img">
                  <img src="../../../../public/img/bigdata/broadcast-icon.png" alt="">
                </div>
                <div class="line-text one-txt-cut">{{item.name}}</div>
                <div class="line-time">{{item.publishTime}}</div>
              </a>
            </div>
            <div style="color: #fff" v-else>

            </div>
          </div>
          <div>
            <!--<div class="page">-->
              <!--<a-pagination-->
                <!--v-model="pagination.current"-->
                <!--:show-total="total => `共${pagination.total}条记录  第${pagination.current}/${NumberDiv(pagination.total,10)}页`"-->
                <!--:total="pagination.total"-->
                <!--:page-size="pagination.pageSize"-->
                <!--@showSizeChange="onShowSizeChange"-->
                <!--@change="handleTableChange"-->
              <!--&gt;-->
                <!--<template slot="buildOptionText" slot-scope="props">-->
                  <!--<span>{{ props.value }}条/页</span>-->
                <!--</template>-->
              <!--</a-pagination>-->
            <!--</div>-->
            <div class="page">
              <el-pagination
                  background
                  layout="total,slot, prev, pager, next"
                  :page-size="10"
                  :current-page='pagination.page'
                  @current-change='handleTableChange'
                  :total="pagination.total">
                <span class="page-left">第{{pagination.page}}/{{NumberDiv(pagination.total,10)}}页</span>
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="message-main">
        <div class="title">360PAI招商消息公告</div>
        <div class="category">
          <div :class="canvass===''?'item active':'item'">
            <div class="type" @click="selectCanvass('')">全部</div>
          </div>
          <div :class="canvass==='1'?'item active':'item'">
            <div class="type" @click="selectCanvass('1')">报名通知</div>
          </div>
          <div :class="canvass==='2'?'item active':'item'">
            <div class="type" @click="selectCanvass('2')">结束通知</div>
          </div>
        </div>
        <div class="message-data">
          <div v-if="loading2" style="width: 100%;height: 100px;line-height: 100px;text-align: center;">

          </div>
          <div v-else>
            <div v-if="canvassList.length">
              <a target="_blank" :href="item.href" class="message-line" v-for="(item,index) in canvassList" :key="index">
                <div class="line-img">
                  <img src="../../../../public/img/bigdata/broadcast-icon.png" alt="">
                </div>
                <div class="line-text one-txt-cut">{{item.name}}</div>
                <div class="line-time">{{item.publishTime}}</div>
              </a>
            </div>
            <div style="color: #fff" v-else>

            </div>
          </div>
          <div>
            <!--<div class="page">-->
              <!--<a-pagination-->
                <!--v-model="pagination2.current"-->
                <!--:show-total="total => `共${pagination2.total}条记录  第${pagination2.current}/${NumberDiv(pagination2.total,10)}页`"-->
                <!--:total="pagination.total2"-->
                <!--:page-size="pagination.pageSize"-->
                <!--@showSizeChange="onShowSizeChange2"-->
                <!--@change="handleTableChange2"-->
              <!--&gt;-->
                <!--<template slot="buildOptionText" slot-scope="props">-->
                  <!--<span>{{ props.value }}条/页</span>-->
                <!--</template>-->
              <!--</a-pagination>-->
            <!--</div>-->
            <div class="page">
              <el-pagination
                      background
                      layout="total,slot, prev, pager, next"
                      :page-size="10"
                      :current-page='pagination2.page'
                      @current-change='handleTableChange2'
                      :total="pagination2.total">
                <span class="page-left">第{{pagination.page}}/{{NumberDiv(pagination2.total,10)}}页</span>
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getAuction,getCanvass} from "../../../api/organization";
  import dataTop from "../index/components/dataTop";
  export default {
    name: "messageCenter",
    components: {
      dataTop,
    },
    data() {
      return {
        Width: 0,
        publishTimeFrom: '',
        publishTimeTo: '',
        auction: '',
        canvass: '',
        loading: false,
        loading2: false,
        auctionList: [],
        canvassList: [],
        data: '',
        pagination: {
          page:1,
          total: 0,
          pageSize: 10,
          lessee:'',
          assetAddressDetail:'',
          lesseeIndustry:'',
          warningType:'',
          assetCompanyId:-1,
        },
        pagination2: {
          page:1,
          total: 0,
          pageSize: 10,
          lessee:'',
          assetAddressDetail:'',
          lesseeIndustry:'',
          warningType:'',
          assetCompanyId:-1,
        },
      }
    },
    methods: {
      NumberDiv (arg1,arg2){
        var pages=arg1%arg2==0?(arg1/arg2):(Math.floor(arg1/arg2)+1);
        return Number(pages);
      },
      handleTableChange(page){
        this.pagination.page = page;
        this.getAuctionList();
      },
      handleTableChange2(page){
        this.pagination2.page = page;
        this.getCanvassList();
      },
      onShowSizeChange(current, pageSize) {
        this.pagination.pageSize = pageSize;
        this.pagination.current = 1;
        this.getAuctionList();
      },
      onShowSizeChange2(current, pageSize) {
        this.pagination2.pageSize = pageSize;
        this.pagination2.current = 1;
        this.getCanvassList();
      },
      getWindowWidth() {
        this.Width = window.innerWidth
      },
      onChange(){
        this.publishTimeFrom = this.data[0]||''
        this.publishTimeTo = this.data[1]||''
        this.pagination.page = 1;
        this.pagination2.page = 1;
        this.getAuctionList();
        this.getCanvassList();
      },
      selectAuction(data){
        this.auction = data;
        this.getAuctionList();
      },
      selectCanvass(data){
        this.canvass = data;
        this.getCanvassList();
      },
      getAuctionList(){
        let para = {
          type : this.auction,
          publishTimeFrom: this.publishTimeFrom,
          publishTimeTo: this.publishTimeTo,
          page: this.pagination.page,
          perPage: this.pagination.pageSize
        }
        this.loading = true;
        getAuction(para).then(res => {
          this.loading = false
          let data = res.data
          if (data.code === '000') {
            this.auctionList = data.content.list;
            this.pagination.total = data.content.total;
          } else {

          }
        }).catch(err => {
          this.loading = false
          console.log(err);
        }).finally(() => {
          this.loading = false
        })
      },
      getCanvassList(){
        let para = {
          type : this.canvass,
          publishTimeFrom: this.publishTimeFrom,
          publishTimeTo: this.publishTimeTo,
          page: this.pagination2.page,
          perPage: this.pagination2.pageSize
        }
        this.loading2 = true;
        getCanvass(para).then(res => {
          this.loading2 = false
          let data = res.data
          if (data.code === '000') {
            this.canvassList = data.content.list;
            this.pagination2.total = data.content.total;
          } else {

          }
        }).catch(err => {
          this.loading2 = false
          console.log(err);
        }).finally(() => {
          this.loading2 = false
        })
      }
    },
    created() {
      this.getAuctionList();
      this.getCanvassList();
    },
    mounted() {
      this.getWindowWidth()
      window.addEventListener('resize', this.getWindowWidth)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth)
    }
  }
</script>
<style lang="scss">
  .bigData-index .el-input__inner{
    border: 1px solid #6FA9FB;
    background-color: #061033;
    color: #B8D7FF;
  }
  .bigData-index .el-date-editor .el-range-input{
    background-color: #061033;
    color: #B8D7FF;
  }
  .page {
    margin-top:20px;
    text-align:right;
    .el-pagination__total{
      color:#fff;
      float: left;
    }
    .page-left{
      font-weight: 400;
      color:#fff;
      float: left;
    }
    .el-pagination .btn-prev {
      color:#606266;
      background: #FFFFFF !important;
      border-radius: 2px;
    }
    .el-pagination .btn-next {
      color:#606266;
      background: #FFFFFF !important;
      border-radius: 2px;
    }
    .el-pager li {
      color:#606266;
      background: #FFFFFF !important;
      border-radius: 2px;
    }
    .el-pager li.active {
      background: #0A56C5 !important;
      color:#fff !important;
      border-radius: 2px;
    }
  }
</style>
<style scoped lang="scss">
  .message-frame{
    overflow: hidden;
    .message-main{
      float: left;
      width: 50%;
      box-sizing: border-box;
      padding: 0 10px;
      .title{
        font-size: 24px;
        color: #fff;
        line-height: 24px;
        padding:33px 0 25px;
      }
      .category{
        color:#fff;
        display:flex;
        align-items: center;
        margin-bottom: 20px;
        .item{
          text-align: center;
          .type{
            padding:4px 15px;
            border:1px solid #fff;
            border-right:none;
            margin-bottom: 4px;
            cursor: pointer;
            border-radius:0px 2px 2px 0px;
          }
          span{
            color:#F5A623;
          }
        }
        .item:last-child .type{
          border-right:1px solid #fff;
        }
        .item.active .type{
          background-color: #0A56C5;
        }
      }
      .message-data{
        .message-line{
          display: flex;
          align-items: center;
          line-height: 60px;
          height: 60px;
          justify-items: center;
          .line-img{
            width: 24px;
            height: 22px;
            margin-right: 20px;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .line-text{
            color: #B8D7FF;
            font-size: 16px;
            flex: 1;
            padding-right: 20px;
          }
          .line-time{
            font-size: 14px;
            color: #fff;
          }
        }
      }
    }
  }
  .message-title{
    line-height: 40px;
    padding-left: 10px;
    padding-top: 20px;
    display: flex;
    .message-l{
      font-size: 28px;
      color: #fff;
      padding-right: 11px;
    }
    .message-r{
      font-size: 12px;
      color: #6FA9FB;
      padding-right: 15px;
    }
  }
  .bigData-index {
    padding: 0 15px 15px;
    background-color: #061033;
    min-height: 100vh;
    width: 100%;
  }
  @media screen and (max-width: 1920px) {
    .bigData-container {
      width: 1366px;
      margin: 0 auto;
    }
  }
  @media screen and (min-width: 1903px) {
    .bigData-container {
      width: 100%;
      margin: 0 auto;
    }
  }
</style>
